/**
 * A reward screen (core slices.ts S4): a check that draws itself (--dur-draw; still under prefers-reduced-motion), the title with the
 * real numbers, a line or two, and whatever comes next (one next-slice offer, the screen's own buttons). It stays until the person
 * leaves: never a timed toast.
 */
import type { ReactNode } from "react";

export function RewardCheck() {
  return (
    <svg className="check-draw reward-check" viewBox="0 0 48 48" width="72" height="72" fill="none" aria-hidden="true">
      <circle cx="24" cy="24" r="22" fill="var(--go-bg)" stroke="var(--go)" strokeWidth="3" />
      <path className="check-draw-path" d="M14 25l7 7 13-15" pathLength={40} stroke="var(--go)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function RewardCard({ title, lines, big, children, testId = "reward", titleClass }: { title: string; lines: readonly string[]; big?: string; children?: ReactNode; testId?: string; titleClass?: string }) {
  return (
    <div className="reward-card" role="status" data-testid={testId}>
      <RewardCheck />
      <h2 className={`reward-title${titleClass ? ` ${titleClass}` : ""}`}>{title}</h2>
      {big && <p className="reward-big" data-testid={`${testId}-big`}>{big}</p>}
      {lines.map((l) => <p key={l} className="reward-line">{l}</p>)}
      {children}
    </div>
  );
}
